export class VibrationPowerMode {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new VibrationPowerMode (
      this.hash,
      this.name
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/vibration-power-mode.ts